import { update_menu } from '../modules/menu';
import { sliders } from '../modules/sliders';
import { active_section } from '../modules/waypoints';
import { rerun_gravity_forms_scripts, rerun_search_scripts, rerun_issuu } from '../modules/forms';
import { copy_link, setup_back_to_top, setup_scrolling } from '../modules/page';

export default {
	init() {
		// JavaScript to be fired on all pages
		$('.header-sub-menu')
			.find('.active')
			.removeClass('active')
			.fadeOut(200);
		
		$('.header-sub-menu').css('height', '');

		update_menu();
		setup_scrolling();
		setup_back_to_top();
		sliders();
		active_section();
		rerun_gravity_forms_scripts();
		copy_link();
		rerun_search_scripts();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		rerun_issuu();
	},
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js